import { ReactNode } from "react";
import { Focusable } from "react-aria";
import { Tooltip } from "@fidelix/fx-miranda";
import { t } from "@lingui/core/macro";
import { styled } from "styled-components";

type Props = {
  isDisconnected: boolean;
  children: ReactNode;
};

export function DeviceDisconnectedTooltip({ isDisconnected, children }: Props) {
  if (!isDisconnected) {
    return children;
  }

  // Disabled buttons don't emit hover events, so the tooltip is triggered by a wrapper
  return (
    <Tooltip content={t`Connection to the device has been lost`}>
      <Focusable>
        <TriggerWrapper role="button" aria-disabled="true">
          {children}
        </TriggerWrapper>
      </Focusable>
    </Tooltip>
  );
}

const TriggerWrapper = styled.span`
  display: inline-flex;
  width: fit-content;
  cursor: not-allowed;

  & * {
    pointer-events: none;
  }
`;
